import { apiHost } from '../../../config';
import { get } from '../../requests';

export default async function getAllCities() {
  return get(`${apiHost}/api/admin/cities`);
}
